import React, { useState } from 'react';

import { ImportService } from '@qality/common-service';

import { mapErrorsToMessages } from './ErrorMapper';
import { ImportTestCasesStatusContext } from './ImportTestCasesStatusContext';

export const ImportTestCasesStatusProvider = ({ children }: any) => {
  const [isImportFinished, setIsImportFinished] = useState(false);
  const [importErrorObject, setImportErrorObject] = useState(null);
  const [importResponse, setImportResponse] = useState({});
  const [errorMessages, setErrorMessages] = useState([]);

  const importTestCases = async (
    projectId,
    mapping,
    data,
    fields,
    delimiter
  ) => {
    try {
      const importServiceResponse = await ImportService.importTestCases(
        projectId,
        mapping,
        data,
        fields,
        delimiter
      );
      setIsImportFinished(true);
      setImportResponse(importServiceResponse.data);
      setErrorMessages(mapErrorsToMessages(importServiceResponse.data.errors));
    } catch (e) {
      setImportErrorObject(e);
      setIsImportFinished(true);
    }
  };

  const resetContext = () => {
    setIsImportFinished(false);
    setImportResponse({});
  };

  return (
    <ImportTestCasesStatusContext.Provider
      value={{
        isImportFinished,
        importErrorObject,
        importResponse,
        importTestCases,
        errorMessages,
        resetContext,
      }}
    >
      {children}
    </ImportTestCasesStatusContext.Provider>
  );
};
